import FuseLoading from '@fuse/core/FuseLoading';
import { Delete, Edit } from '@mui/icons-material';
import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useDeleteAppointmentMutation,
  useGetAllAppointmentPurposeQuery,
} from 'src/app/services/appointmentApi';
import AppointmentPurposeForm from './appointmentPurposeForm';
import SimpleDialog from '@fuse/core/SimpleDialog';
import ConfirmDeleteModalWindow from 'app/shared-components/confirmDeleteModalWindow';
import useMessage from 'src/app/hooks/useMessage';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import handleError from '@fuse/core/errorHandler';

const AppointmentPurpose = () => {
  const { t } = useTranslation('translations');
  const [currentStatus, setCurrentStatus] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isOpenedModal, setIsOpenedModal] = useState(false);
  const [selected, setSelected] = useState(null);

  const { data: appointments = [], refetch, isLoading } = useGetAllAppointmentPurposeQuery();
  const [deleteAppointment] = useDeleteAppointmentMutation();
  const { showMessage } = useMessage();

  const handleDeleteAppointment = (appointments) => {
    deleteAppointment({ id: appointments.id })
      .unwrap()
      .then(() => {
        showMessage({ message: t('DataSuccessfullyDeleted'), variant: 'success' });
        refetch();
      })
      .catch(handleError);
  };

  const showNewItemDialog = () => {
    setCurrentStatus(null);
    setIsDialogOpen(true);
  };

  const showEditDialog = (appointments) => {
    setCurrentStatus(appointments);
    setIsDialogOpen(true);
  };

  const handleShowModal = (appointments) => {
    setSelected(appointments);
    setIsOpenedModal(true);
  };

  const handleCloseModal = () => {
    setIsOpenedModal(false);
  };

  return (
    <div style={{ display: 'grid' }}>
      {isLoading ? (
        <FuseLoading />
      ) : (
        <TableContainer>
          <div className="h-[40px] flex flex-row justify-between items-center dark:bg-dark">
            <h2 className="ml-5"> {t('AppointmentTypes')}</h2>
            <Button
              className="mx-8"
              size="small"
              variant="outlined"
              color="secondary"
              onClick={showNewItemDialog}
            >
              <FuseSvgIcon size={20}>react-outline:plus</FuseSvgIcon>
              <span className="mx-8">{t('Add')}</span>
            </Button>
          </div>

          <Table style={{ overflow: 'auto' }}>
            <TableHead>
              <TableRow className="dark:bg-dark">
                <TableCell>{t('Title') + ' (uz)'}</TableCell>
                <TableCell>{t('Title') + ' (рус)'}</TableCell>
                <TableCell>{t('Actions')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className=" overflow-y-auto">
              {appointments &&
                appointments?.map((item) => (
                  <TableRow key={item.id} className="bg-white hover:bg-grey-200 dark:bg-dark">
                    <TableCell>{item.nameUz}</TableCell>
                    <TableCell>{item.nameRu}</TableCell>
                    <TableCell>
                      <Box className="flex">
                        <IconButton
                          edge="end"
                          aria-label="edit"
                          className="mr-5"
                          color="info"
                          onClick={() => showEditDialog(item)}
                        >
                          <Edit />
                        </IconButton>
                        <IconButton
                          onClick={() => handleShowModal(item)}
                          className="mr-10"
                          color="error"
                        >
                          <Delete />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <SimpleDialog
            title={currentStatus ? t('DataSuccessfullyUpdated') : t('DataSuccessfullyReceived')}
            open={isDialogOpen}
            onClose={() => setIsDialogOpen(false)}
          >
            <AppointmentPurposeForm
              appointmentStatus={currentStatus}
              refetch={refetch}
              onClose={() => setIsDialogOpen(false)}
              isEdit={currentStatus ? true : false}
            />
          </SimpleDialog>
        </TableContainer>
      )}
      {isOpenedModal && (
        <ConfirmDeleteModalWindow
          onClose={handleCloseModal}
          setIsOpenModal={setIsOpenedModal}
          modalTitle={'AreYouSureToDeleteAppointmentType'}
          deleteMessage={() => handleDeleteAppointment(selected)}
          open={isOpenedModal}
        />
      )}
    </div>
  );
};

export default AppointmentPurpose;
